import { CSSObject, Drawer, styled, Theme, useMediaQuery, useTheme } from "@mui/material";
import { closeTransition, drawerClosedWidth, drawerWidth, HeaderPad, minDrawerThreshold, openTransition } from "..";
import DrawerContent from "./drawer-content";
import { McpDrawerProvider } from "./drawer-context";
import McpBackDrop from "../backdrop";

/////// NO TOCAR ESTO {
interface McpDrawerProps {
    open: boolean,
    hover: boolean,
    setOpen: (value: boolean) => void,
    setHover: (value: boolean) => void
}

const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: openTransition(theme),
    overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
    width: drawerClosedWidth,
    transition: closeTransition(theme),
    overflowX: 'hidden'
});

const StyledDrawer = styled(Drawer)(() => ({
    '& .MuiDrawer-paper': {
        width: drawerWidth,
        borderColor: "primary.dark",
        backgroundColor: "primary.main"
    },
}))

const MinDrawer = styled(StyledDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme }) => ({
        width: drawerWidth,
        '& .MuiDrawer-paper': {
            zIndex: theme.zIndex.appBar - 1,
        },
        variants: [
            {
                props: ({ open }) => open,
                style: { ...openedMixin(theme), '& .MuiDrawer-paper': openedMixin(theme), },
            },
            {
                props: ({ open }) => !open,
                style: { ...closedMixin(theme), '& .MuiDrawer-paper': closedMixin(theme), },
            },
        ],
    })
)

export default function McpDrawer({
    open,
    hover,
    setOpen,
    setHover
}: McpDrawerProps) {
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down(minDrawerThreshold))

    const renderDrawer = ()=>{
        if (smallScreen) {
            return <StyledDrawer PaperProps={{ component: "aside" }} variant="temporary" onClose={() => setOpen(false)} 
                open={open} disableEnforceFocus >
                <DrawerContent />
            </StyledDrawer>
        } else {
            return <>
                <MinDrawer PaperProps={{ component: "aside" }} variant="permanent" onClose={() => setOpen(false)}
                    open={open||hover} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)} >
                    <HeaderPad />
                    <DrawerContent />
                </MinDrawer>
                <McpBackDrop open={hover && !open}/>
            </>
        }
    }

    return <McpDrawerProvider drawerOpen={open||hover} setDrawerOpen={setOpen}>
        {renderDrawer()}
    </McpDrawerProvider>
}
/////// }